import { Dispatch, SetStateAction } from 'react';
import useAuth from 'hooks/useAuth';
import UserInfoPanel from 'components/UserInfo/UserInfoPanel';
import Modal, { Sheets, ModalHeader, ModalFooter, ModalBody } from '@ingka/modal';

const UserInfoModal = (
    {
        isOpen,
        setIsOpen
    }: {
        isOpen: boolean,
        setIsOpen: Dispatch<SetStateAction<boolean>>
    }
) => {
    const { user } = useAuth();

    return (
        <Modal
            visible={isOpen}
            escapable
            handleCloseBtn={() => setIsOpen(false)}
        >
            <Sheets
                alignment="right"
                size="small"
                header={(<ModalHeader />)}
                footer={(<ModalFooter><div /></ModalFooter>)}
            >
                <ModalBody>
                    <UserInfoPanel user={user} />
                </ModalBody>
            </Sheets>
        </Modal>
    );
};

export default UserInfoModal;
